var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow overflow-hidden sm:rounded-lg flex flex-col",
      class:
        _vm.clickable &&
        "cursor-pointer hover:shadow-xl transition duration-300",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm._t("head"),
      _c("div", { staticClass: "px-4 py-5 sm:px-6" }, [
        _c(
          "dl",
          {
            staticClass: "grid grid-cols-1 col-gap-4 row-gap-8 sm:grid-cols-2",
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }